// 1. React Router
import { useLocation } from "react-router-dom";

// 2. UI Components (from shared/common libraries)
import { H2 } from "../../../../AbstractElements";
import FinancialYearCycle from "../../../../CommonElements/YearPickerCycle";

// 3. Constants
import { Attendance } from "../../../../utils/Constant";

// 4. Types
import { AttendanceHeaderProps } from "../../types";

const AttendanceHeader = ({
  loggedInEmployeeRole,
  employeeRole,
  selectedFinancialYear,
  handleSetSelectedYear,
}: AttendanceHeaderProps) => {
  const location = useLocation();
  const shouldShowTitle = !location.pathname.includes("/user-management/user");
  const shouldShowFinancialYear = !["supportstaff", "officeboy"].includes(
    loggedInEmployeeRole ?? employeeRole ?? ""
  );

  return (
    <div
      className={`d-flex justify-content-${
        shouldShowTitle ? "between" : "end"
      } align-items-center`}
    >
      {shouldShowTitle && <H2 className="mb-1 f-16">{Attendance}</H2>}
      {shouldShowFinancialYear && (
        <FinancialYearCycle
          endMonth={8}
          startMonth={9}
          endDateValue={30}
          startDateValue={1}
          selectedYear={selectedFinancialYear ?? ""}
          setSelectedYear={handleSetSelectedYear}
        />
      )}
    </div>
  );
};

export default AttendanceHeader;
